import { ProcessState } from "./models";
import { makeAutoObservable, runInAction } from "mobx";
export class ReportStoreImpl {
    constructor(rootStore, serviceClient) {
        this.reportState = ProcessState.SUCCESS;
        makeAutoObservable(this);
        this.serviceClient = serviceClient;
        this.rootStore = rootStore;
    }
    monitorTaskId(taskId) {
        this.serviceClient
            .then((client) => client.apis.task.getTaskStatus({ taskId: taskId }, {}))
            .then((response) => {
            const taskStatus = response.body;
            if (taskStatus.isPending) {
                setTimeout(() => {
                    this.monitorTaskId(taskId);
                }, 3000);
            }
            else if (taskStatus.isFinishedSuccess) {
                this.rootStore.jobPanelStore.loadJobPanels();
                runInAction(() => { this.reportState = ProcessState.SUCCESS; });
            }
            else {
                this.rootStore.notificationStore.enqueueSnackbar("Refreshing report failed");
                runInAction(() => { this.reportState = ProcessState.ERROR; });
            }
        })
            .catch((error) => {
            this.rootStore.notificationStore.handleError(error);
            runInAction(() => { this.reportState = ProcessState.ERROR; });
        });
    }
    updateReport() {
        this.reportState = ProcessState.LOADING;
        this.serviceClient
            .then((client) => client.apis.task.startReportUpdate({}, {}))
            .then((response) => {
            const taskData = response.body;
            this.monitorTaskId(taskData.taskId);
        })
            .catch((error) => {
            this.rootStore.notificationStore.handleError(error);
            runInAction(() => { this.reportState = ProcessState.ERROR; });
        });
    }
}
